"use strict";
/**
 * 板块页面
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageBanKuai = void 0;
var react_1 = __importDefault(require("react"));
var crumbs_1 = require("../crumbs");
var layout_1 = require("./shared/layout");
var mini_time_chart_1 = require("./shared/mini_time_chart");
var title_quotetable_1 = require("./shared/title/title_quotetable");
function PageBanKuai() {
    return (react_1.default.createElement("div", { className: "pagebankuai" },
        react_1.default.createElement(crumbs_1.CrumbsWithRefreshLine, null),
        react_1.default.createElement(layout_1.Layout4, { mt: 5 },
            react_1.default.createElement(layout_1.Layout4.Item, null,
                react_1.default.createElement(mini_time_chart_1.Title1MiniTimeChart, { quotecode: "1.000001", height: 185, border: false }, "\u4E0A\u8BC1\u6307\u6570")),
            react_1.default.createElement(layout_1.Layout4.Item, null,
                react_1.default.createElement(mini_time_chart_1.Title1MiniTimeChart, { quotecode: "0.399001", height: 185, border: false }, "\u6DF1\u8BC1\u6307\u6570")),
            react_1.default.createElement(layout_1.Layout4.Item, null,
                react_1.default.createElement(mini_time_chart_1.Title1MiniTimeChart, { quotecode: "0.399006", height: 185, border: false }, "\u521B\u4E1A\u6307\u6570")),
            react_1.default.createElement(layout_1.Layout4.Item, null,
                react_1.default.createElement(title_quotetable_1.Title1QuoteTable, { table_key: 'BoardsCPDesc2',
                    fs: 'm:90+s:4,m:90+t:3+f:!50,m:90+t:1+f:!50',
                    count: 5,
                    order: 'f3',
                    orderdur: 1 }, "\u9886\u6DA8\u677F\u5757"))),
        react_1.default.createElement(layout_1.Layout2, { mt: 10 },
            react_1.default.createElement(layout_1.Layout2.Item, null,
                react_1.default.createElement(title_quotetable_1.Title2QuoteTable, { more: react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("a", { href: "//data.eastmoney.com/bkzj/hy.html" },
                            react_1.default.createElement("em", { className: "icon_exchange2" }),
                            "\u884C\u4E1A\u677F\u5757\u8D44\u91D1\u6D41"),
                        " ",
                        react_1.default.createElement("a", { href: "//data.eastmoney.com/report/hyyb.html" },
                            react_1.default.createElement("em", { className: "icon_book" }),
                            "\u884C\u4E1A\u7814\u62A5"),
                        " ",
                        react_1.default.createElement("a", { href: "gridlist.html#industry_board" }, "\u66F4\u591A>>")), bottom_more: react_1.default.createElement("a", { href: "gridlist.html#industry_board" }, "\u70B9\u51FB\u67E5\u770B\u5168\u90E8\u884C\u4E1A\u6DA8\u5E45>>"), table_key: 'BoardsCPDesc3',
                    fs: 'm:90+s:4',
                    count: 10,
                    order: 'f3',
                    orderdur: 1,
                    xgtype: 'bk_hy' }, "\u884C\u4E1A\u677F\u5757\u6DA8\u5E45")),
            react_1.default.createElement(layout_1.Layout2.Item, null,
                react_1.default.createElement(title_quotetable_1.Title2QuoteTable, { more: react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("a", { href: "gridlist.html?sr=0#industry_board" }, "\u66F4\u591A>>")), bottom_more: react_1.default.createElement("a", { href: "gridlist.html?sr=0#industry_board" }, "\u70B9\u51FB\u67E5\u770B\u5168\u90E8\u884C\u4E1A\u8DCC\u5E45>>"), table_key: 'BoardsCPDesc4',
                    fs: 'm:90+s:4',
                    count: 10,
                    order: 'f3',
                    orderdur: 0,
                    xgtype: 'bk_hy' }, "\u884C\u4E1A\u677F\u5757\u8DCC\u5E45"))),
        react_1.default.createElement(layout_1.Layout2, { mt: 10 },
            react_1.default.createElement(layout_1.Layout2.Item, null,
                react_1.default.createElement(title_quotetable_1.Title2QuoteTable, { more: react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("a", { href: "//data.eastmoney.com/bkzj/gn.html" },
                            react_1.default.createElement("em", { className: "icon_exchange2" }),
                            "\u6982\u5FF5\u677F\u5757\u8D44\u91D1\u6D41"),
                        " ",
                        react_1.default.createElement("a", { href: "gridlist.html#concept_board" }, "\u66F4\u591A>>")), bottom_more: react_1.default.createElement("a", { href: "gridlist.html#concept_board" }, "\u70B9\u51FB\u67E5\u770B\u5168\u90E8\u6982\u5FF5\u6DA8\u5E45>>"), table_key: 'BoardsCPDesc3',
                    fs: 'm:90+t:3',
                    count: 10,
                    order: 'f3',
                    orderdur: 1,
                    xgtype: 'bk_hy' }, "\u6982\u5FF5\u677F\u5757\u6DA8\u5E45")),
            react_1.default.createElement(layout_1.Layout2.Item, null,
                react_1.default.createElement(title_quotetable_1.Title2QuoteTable, { more: react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("a", { href: "gridlist.html?sr=0#concept_board" }, "\u66F4\u591A>>")), bottom_more: react_1.default.createElement("a", { href: "gridlist.html?sr=0#concept_board" }, "\u70B9\u51FB\u67E5\u770B\u5168\u90E8\u6982\u5FF5\u8DCC\u5E45>>"), table_key: 'BoardsCPDesc4',
                    fs: 'm:90+t:3',
                    count: 10,
                    order: 'f3',
                    orderdur: 0,
                    xgtype: 'bk_hy' }, "\u6982\u5FF5\u677F\u5757\u8DCC\u5E45"))),
        react_1.default.createElement(layout_1.Layout2, { mt: 10 },
            react_1.default.createElement(layout_1.Layout2.Item, null,
                react_1.default.createElement(title_quotetable_1.Title2QuoteTable, { more: react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("a", { href: "//data.eastmoney.com/bkzj/dy.html" },
                            react_1.default.createElement("em", { className: "icon_exchange2" }),
                            "\u5730\u57DF\u677F\u5757\u8D44\u91D1\u6D41"),
                        " ",
                        react_1.default.createElement("a", { href: "gridlist.html#region_board" }, "\u66F4\u591A>>")), bottom_more: react_1.default.createElement("a", { href: "gridlist.html#region_board" }, "\u70B9\u51FB\u67E5\u770B\u5168\u90E8\u5730\u57DF\u6DA8\u5E45>>"), table_key: 'BoardsCPDesc3',
                    fs: 'm:90+t:1',
                    count: 10,
                    order: 'f3',
                    orderdur: 1,
                    xgtype: 'bk_hy' }, "\u5730\u57DF\u677F\u5757\u6DA8\u5E45")),
            react_1.default.createElement(layout_1.Layout2.Item, null,
                react_1.default.createElement(title_quotetable_1.Title2QuoteTable, { more: react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("a", { href: "gridlist.html?sr=0#region_board" }, "\u66F4\u591A>>")), bottom_more: react_1.default.createElement("a", { href: "gridlist.html?sr=0#region_board" }, "\u70B9\u51FB\u67E5\u770B\u5168\u90E8\u5730\u57DF\u8DCC\u5E45>>"), table_key: 'BoardsCPDesc4',
                    fs: 'm:90+t:1',
                    count: 10,
                    order: 'f3',
                    orderdur: 0,
                    xgtype: 'bk_hy' }, "\u5730\u57DF\u677F\u5757\u8DCC\u5E45")))));
}
exports.PageBanKuai = PageBanKuai;
